import { useThemeStore } from "@/store/theme";

function replaceImageThumbnail(source, to) {
    return source.replace("360", to);
}

export function defineThumbnail(imagePath) {
    //GET WITH OF THE IMAGE
    let w = window.innerWidth;

    //DEFINE THUMBNAIL
    let wantedSize = "";
    if (w >= 1320) wantedSize = "1920";
    else if (w >= 800 && w < 1320) wantedSize = "1280";
    else if (w >= 480 && w < 800) wantedSize = "720";
    else if (w < 480) wantedSize = "360";

    return (
        process.env.VUE_APP_API_URL +
        replaceImageThumbnail(imagePath, wantedSize)
    );
}

export function getImagesForLightBox(images) {
    let array = [];
    if (images?.length > 0) {
        images.forEach((e) => {
            if (e?.element?.fullpath) {
                array.push(defineThumbnail(e.element.fullpath));
            } else if (e?.image?.fullpath) {
                array.push(defineThumbnail(e.image.fullpath));
            } else if (e?.element?.images?.[0]?.image?.fullpath) {
                array.push(defineThumbnail(e?.element?.images?.[0]?.image?.fullpath));
            }
        });
    }
    return array;
}

export function trimmedLink(link) {
    return link.split("/").slice(2).join("/");
}

export function changeDateToLanguage(date, language, showYear = true) {
    const newDate = new Date(date);
    const options = { day: "numeric", month: "long" };

    if (showYear) {
        options.year = "numeric";
    }

    return newDate.toLocaleDateString(language, options);
}

export function getNewsImage(news) {
    const themeStore = useThemeStore();
    const newsDefaultImage = themeStore.news.defaultImage;

    if (news?.node?.imageTeaser && news?.node?.imageTeaser[0]) {
        return news.node.imageTeaser[0]
    }

    return newsDefaultImage;
}

export function getNavigationListItemProps(page) {
    if (page.externalUrl) {
        return { href: page.externalUrl, target: '_blank' };
    } else if (page.url) {
        return { to: '/' + page.url };
    }
    return {};
}

export function getUniqueNewsCategories(news) {
    const categories = new Set();
    categories.add("Alle");

    news.forEach(newsItem => {
        if (newsItem?.node?.categories) {
            newsItem.node.categories.forEach(category => {
                categories.add(category.name);
            });
        }
    });

    return Array.from(categories);
}

export function getVideoIframeAttributes(type, id, urlOptions = '') {
    const attributes = {}

    const baseUrl =
        type === 'youtube' ? 'https://www.youtube.com/embed/' :
            type === 'vimeo' ? 'https://player.vimeo.com/video/' : ''
    const url = baseUrl + id + urlOptions

    const themeStore = useThemeStore()
    if (themeStore.cookiebotConsent) {
        attributes['data-src'] = url
        attributes['data-cookieconsent'] = 'statistics'
        attributes.class = ''
    } else {
        attributes.src = url
    }

    attributes.allowfullscreen = true
    attributes.mozallowfullscreen = true
    attributes.webkitallowfullscreen = true
    attributes.frameborder = 0

    if (type === 'youtube') {
        attributes.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    }

    return attributes
}

export function loadCookiebot() {
    if (window.Cookiebot) {
        window.Cookiebot.runScripts()
    }
}
